export const REQUEST_OTP = "REQUEST_OTP";
export const RE_REQUEST_OTP = "RE_REQUEST_OTP";
export const CONFIRM_OTP = "CONFIRM_OTP";

export const ON_API_CALL = "ON_API_CALL";
export const ON_RESEND_API_CALL_ERROR = "ON_RESEND_API_CALL_ERROR";
export const ON_COMFIRM_OTP_API_CALL_ERROR = "ON_COMFIRM_OTP_API_CALL_ERROR";

export const CLEAR_AUTH = "ON_CLEAR_AUTH";